/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_Err_InstInputs */

const en_cp_form_err_inst = /** @type {(inputs: Cp_Form_Err_InstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the institution name.`)
};

const id_cp_form_err_inst = /** @type {(inputs: Cp_Form_Err_InstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isi nama institusi.`)
};

/**
* | output |
* | --- |
* | "Enter the institution name." |
*
* @param {Cp_Form_Err_InstInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_err_inst = /** @type {((inputs?: Cp_Form_Err_InstInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_Err_InstInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_err_inst(inputs)
	return en_cp_form_err_inst(inputs)
});